import CustomBarChartWithCircle from "./CustomBarChartWithCircle";

export default CustomBarChartWithCircle;



// WEBPACK FOOTER //
// ./src/components/d3Components/customBarchartWithCircle/index.js